module.exports = __webpack_public_path__ + "static/media/Prestigia.fca57ca6.png";